<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <base-input label="Site Selection" class="col-md-6">
                            <a-select mode="multiple" style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="selectedSiteId" :disabled="site_type != 'ho'">
                                <a-select-option v-for="site in validSites" :key="site.id" :value="site.id">{{site.name}}</a-select-option>
                            </a-select>
                        </base-input>

                        <base-input label="Report Format" class="col-md-6">
                            <a-select style="width: 100%" placeholder="Please select" v-model="selectedFormat">
                                <a-select-option  :key="1" :value="1">Default</a-select-option>
                                <a-select-option  :key="2" :value="2">Compact</a-select-option>
                            </a-select>
                        </base-input>

                        <base-input v-if="selectedFormat == 1" label="Date Range" class="col-md-6">
                            <br><a-range-picker @change="onDateFilter2" :allowClear="false" :format="dateFormat" input-classes="form-control" style="width: 100%"/>
                        </base-input>

                        <base-input v-if="selectedFormat == 2" label="Date Range" class="col-md-6">
                            <br>
                            <a-range-picker
                              :placeholder="['Start month', 'End month']"
                              format="YYYY-MM"
                              :value="value"
                              :mode="mode2"
                              :allowClear="false"
                              @panelChange="handlePanelChange2"
                              @change="onDateFilter3"
                            />
                            <!-- <a-range-picker :placeholder="['Start month', 'End month']" @panelChange="handlePanelChange2" @change="onDateFilter3" format="YYYY-MM" :mode="mode2" input-classes="form-control" style="width: 100%"/> -->
                        </base-input>

                        <!-- <base-input label="From" class="col-md-6">
                            <br><a-date-picker @change="onDateFilter2" :format="dateFormat" input-classes="form-control" style="width: 100%"/>
                        </base-input>      -->
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button v-if="selectedFormat == 1" @click="generateBIRExcel" class="btn btn-sm btn-success float-right ml-2"
                                    style="border-radius: 24px; border:0px; width: 20%;">
                                Generate Report in Excel
                            </button>
                            <!-- <download-excel
                                v-if="selectedFormat == 1"
                                :fetch   = "fetchData"
                                :fields = "json_fields"
                                worksheet = "BIR Combined Reports"
                                name    = "bir_combined_reports.xls"
                                type = "xls">
                                <button class="btn btn-sm btn-success float-right ml-2" style="border-radius: 24px; border:0px; width: 20%;">Generate Report in Excel</button>
                            </download-excel> -->

                            <download-excel
                                v-if="selectedFormat == 2"
                                :fetch   = "fetchData"
                                :fields = "json_fields2"
                                :stringifyLongNum="true"
                                worksheet = "BIR Combined Reports"
                                name    = "bir_combined_reports_compact.xls"
                                type = "xls">
                                <button class="btn btn-sm btn-success float-right ml-2" style="border-radius: 24px; border:0px; width: 20%;">Generate Report in Excel</button>
                            </download-excel>

                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import { getReportDescription } from '../../utilities';

    function formatNumber(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    const fs = require('fs')

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                spinning: false,
                value: [],
                mode2: ['month', 'month'],
                selectedFormat: 1,
                selectedSiteId: [],
                site_type: "ho",
                dateFormat: 'YYYY-MM-DD',
                validSites: null,
                dateFilter: null,
                searchDateFrom: null,
                searchDateTo: null,
                jsonData: [],
                json_fields2: {
                    "Terminal Name": "terminal_name",
                    "TIN": {
                        field: "site_tin",
                        callback: value => value ? `'${value}` : ''
                    },
                    "TIN Branch Code": {
                        field: "tin_branch_code",
                        callback: value => value ? `'${value}` : ''
                    },
                    "Branch": "site_name",
                    "Month": "month",
                    "Year": "year",
                    "MIN": "machine_no",
                    "Last OR": "last_or",
                    "Vatable Sales": "vatable_sales",
                    "VAT Zero Rated": "zero_rated_sales",
                    "VAT Exempt Sales": "vat_exempt_sales",
                    "Other Taxes": "other_taxes",
                    "VAT Amount": "vat_amount",
                    "NET Sales": "net_sales"
                },
                json_fields: {
                    'Machine No': 'machineNo',
                    'Terminal Code':  'terminaCode',
                    'Business Date':  'businessDate' ,
                    'Invoice Number (From)':  'beginningSi' ,
                    'Invoice Number (To)':  'endingSi' ,
                    'Beginning Balance': 'beginningBalance' ,
                    'Ending Balance': 'endingBalance' ,
                    'Gross Sales': 'grossSales' ,
                    'Vatable Sales': 'grossVatableSales' ,
                    'VAT Amount': 'grossVatAmount' ,
                    'VAT Exempt Sales': 'grossVatExemptSales' ,
                    'Zero Rated Sales': 'grossZeroRatedSales' ,
                    'Deductions (Regular Discount)': 'regularDiscount' ,
                    'Deductions (Special Discount - 5%)': 'specialDiscount' ,
                    'Deductions (Special Discount - 20%)': 'specialDiscount2' ,
                    'Deductions (Return)': 'totalReturns' ,
                    'Deductions (Void)': 'totalVoids' ,
                    'Deductions (Manual)': 'totalReplaced' ,
                    'Total Deductions': 'totalDeductions' ,
                    'Adjustments on VAT (Regular)': 'adjustmentOnVatRegular' ,
                    'Adjustments on VAT (Special - 5%)': 'adjustmentOnVatSpecial' ,
                    'Adjustments on VAT (Special - 20%)': 'adjustmentOnVatSpecial2' ,
                    'Adjustments on VAT (Return)': 'adjustmentOnVatReturns' ,
                    'Adjustments on VAT (Refund)': 'adjustmentOnVatRefund' ,
                    'Adjustments on VAT (Void)': 'adjustmentOnVatVoids' ,
                    'Adjustments on VAT (Manual)': 'adjustmentOnVatManual' ,
                    'Total Adjustments': 'totalVatAdjustments' ,
                    'VAT Payables': 'vatPayables' ,
                    'Net Amount Received': 'netAmountReceived' ,
                    'Other Income (Excess GC)': 'excessGC' ,
                    'Other Income (Excess RS)': 'excessRS' ,
                    'Sales Including Excess': 'salesWithExcess' ,
                    'Reset Counter': 'siResetCount' ,
                    'Z-Counter': 'zReadingCounter'
              },
              reportDescription: ''
            }
        },
        mounted: async function () {
            var userId = secureStorage.getItem("userId")
            var site_data = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_sites?user_id=' + userId, null)
            this.validSites = site_data

            let siteId = secureStorage.getItem("defaultSiteId")
            this.selectedSiteId = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
            this.reportDescription = await getReportDescription(this.currentProfile)
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        methods: {
            moment,
            onDateFilter2(date, dateString) {
                this.searchDateFrom = dateString[0]
                this.searchDateTo = dateString[1]
            },
            onDateFilter3(value) {
                this.value = value;
            },
            handlePanelChange2(value, mode) {
              this.value = value;
              this.mode2 = [mode[0] === 'date' ? 'month' : mode[0], mode[1] === 'date' ? 'month' : mode[1]];
            },
            async fetchData(){
                this.spinning= true;
                if(this.selectedFormat == 2){
                  if (!this.value[0] || !this.value[1]) {
                    this.$notification['error']({
                      message: 'Export Error',
                      description: "Date Range can't be blank. Try increasing the scope by adjusting the filters."
                    });
                    this.spinning= false;
                    return [];
                  } else {
                    this.searchDateFrom = this.value[0] ? this.value[0].startOf('month').format("YYYY-MM-DD") : '';
                    this.searchDateTo = this.value[1] ? this.value[1].endOf('month').format("YYYY-MM-DD") : '';
                  }
                }

                this.jsonData =[];
                var queryResult = await HTTPRequest.getRequest(this.endPoint + `z_readings/bir_combined_report_5_1?format=${this.selectedFormat}&from=` + this.searchDateFrom + "&to=" + this.searchDateTo + "&site_ids=" + this.selectedSiteId , null)
                // var queryResult = await HTTPRequest.getRequest(this.endPoint + 'z_readings/bir_combined_report?from=' + this.dateFilter + "&site_ids=" + this.selectedSiteId , null)
                var siteSpecific = queryResult.report_details

                let reportLengths = siteSpecific.map(a => a.report_details.length)
                console.log("reportLengths")
                console.log(reportLengths)
                let isReportsEmpty = reportLengths.every(reportLength => reportLength == 0)
                console.log("checker")
                console.log(isReportsEmpty)
                if (isReportsEmpty) {
                    this.$notification['warning']({
                    message: 'Export Error',
                    description: 'Empty data. Try increasing the scope by adjusting the filters.'
                    });
                    this.spinning= false;
                    return [];
                }
                
                // var combinedData = []
                if(this.selectedFormat == 1){
                    var siteTotalSales = 0 ,siteTotalVatablesSales = 0 ,siteTotalVatAmount = 0 ,siteTotalVatExemptSales = 0 ,siteTotalZeroRatedSales = 0 ,siteTotalRegularDeductions = 0 ,siteTotalSpecialDeductions = 0 ,siteTotalReturnDeductions = 0 ,siteTotalVoidDeductions = 0 ,siteTotalManualDeductions = 0 ,siteTotalDeductions2 = 0 ,siteTotalVatAdjustmentRegular = 0 ,siteTotalVatAdjustmentSpecial = 0 ,siteTotalVatAdjustmentReturn = 0, siteTotalVatAdjustmentRefund = 0,siteTotalVatAdjustmentVoid = 0 ,siteTotalVatAdjustmentManual = 0 ,siteTotalAdjustment2 = 0 ,siteTotalVatPayables = 0 ,siteTotalNetAmountReceived = 0 ,siteTotalExcessGC = 0 ,siteTotalExcessRS = 0 ,siteTotalSalesIncludingExcess= 0, siteTotalVatAdjustmentSpecial2= 0, siteTotalSpecialDeductions2 = 0;
                    for(var x=0; x < siteSpecific.length; x++){
                        this.birCombinedReports = siteSpecific[x].report_details
                        // console.log("")

                        // if(this.birCombinedReports.length > 0){
                        var reportData = [];
                        var totalSales =0, totalVatablesSales =0, totalVatAmount =0, totalVatExemptSales =0, totalZeroRatedSales =0, totalRegularDeductions =0, totalSpecialDeductions =0, totalSpecialDeductions2 = 0,
                            totalReturnDeductions =0, totalVoidDeductions =0, totalManualDeductions =0, totalDeductions2 =0, totalVatAdjustmentRegular =0,
                            totalVatAdjustmentSpecial =0,totalVatAdjustmentSpecial2 =0,  totalVatAdjustmentReturn =0, totalVatAdjustmentVoid =0, totalVatAdjustmentManual =0, totalAdjustment2 =0,
                            totalVatPayables =0, totalNetAmountReceived =0, totalExcessGC =0, totalExcessRS =0, totalSalesIncludingExcess=0;

                            
                        for(var i=0; i < this.birCombinedReports.length; i++){

                                var reportLine = this.birCombinedReports[i]
                                var reportLineDetails = JSON.parse(reportLine.reading_details)
                                // var reportLineDetails = JSON.parse(JSON.parse(reportLine.reading_details))

                                var vatPayables = reportLineDetails.grossSales.vatAmount - reportLineDetails.adjustmentsOnVat.total
                                // var netAmountReceived = reportLineDetails.grossSales.total - (reportLineDetails.deductions.total + reportLineDetails.adjustmentsOnVat.total)
                                var netAmountReceived = reportLineDetails.netSales
                                var salesWithExcess = netAmountReceived + reportLineDetails.otherIncome.total
                                // var vat_exempt_sales = (parseFloat(reportLineDetails.netSalesBreakdown.vatExempt.toFixed(2)) > 0) ? reportLineDetails.netSalesBreakdown.vatExempt.toFixed(2) : reportLineDetails.grossSales.vatExempt.toFixed(2)
                                var vat_exempt_sales = reportLineDetails.grossSales.vatExempt.toFixed(2)

                                // grossSales
                                totalSales  += parseFloat( reportLineDetails.grossSales.total.toFixed(2) )
                                totalVatablesSales  += parseFloat( reportLineDetails.grossSales.vatable.toFixed(2) )
                                totalVatAmount  += parseFloat( reportLineDetails.grossSales.vatAmount.toFixed(2) )
                                totalVatExemptSales  += parseFloat( vat_exempt_sales )
                                totalZeroRatedSales  += parseFloat( reportLineDetails.grossSales.zeroRated.toFixed(2) )

                                // deductions
                                totalRegularDeductions  += parseFloat( reportLineDetails.deductions.regular.toFixed(2) )
                                totalSpecialDeductions2  += parseFloat( reportLineDetails.deductions.specialVatExemptDiscount.toFixed(2) )
                                totalSpecialDeductions  += parseFloat( reportLineDetails.deductions.specialVatableDiscount.toFixed(2) )
                                totalReturnDeductions  += parseFloat( reportLineDetails.deductions.returns.toFixed(2) )
                                totalVoidDeductions  += parseFloat( reportLineDetails.deductions.void.toFixed(2) )
                                totalManualDeductions  += parseFloat( reportLineDetails.deductions.manual.toFixed(2) )
                                totalDeductions2  += parseFloat( reportLineDetails.deductions.total.toFixed(2) )

                                // adjustmentsOnVat
                                totalVatAdjustmentRegular  += parseFloat( reportLineDetails.adjustmentsOnVat.regular.toFixed(2) )
                                totalVatAdjustmentSpecial2  += parseFloat( reportLineDetails.adjustmentsOnVat.specialVatExemptDiscount.toFixed(2) )
                                totalVatAdjustmentSpecial  += parseFloat( reportLineDetails.adjustmentsOnVat.specialVatableDiscount.toFixed(2) )
                                totalVatAdjustmentReturn  += parseFloat( reportLineDetails.adjustmentsOnVat.returns.toFixed(2) )
                                totalVatAdjustmentVoid  += parseFloat( reportLineDetails.adjustmentsOnVat.void.toFixed(2) )
                                totalVatAdjustmentManual  += parseFloat( reportLineDetails.adjustmentsOnVat.manual.toFixed(2) )
                                totalAdjustment2  += parseFloat( reportLineDetails.adjustmentsOnVat.total.toFixed(2) )


                                totalVatPayables  += parseFloat( vatPayables.toFixed(2))
                                totalNetAmountReceived  += parseFloat( netAmountReceived.toFixed(2) )

                                // otherIncome
                                totalExcessGC  += parseFloat( reportLineDetails.otherIncome.excessGC.toFixed(2) )
                                totalExcessRS  += parseFloat( reportLineDetails.otherIncome.excessRS.toFixed(2) )
                                totalSalesIncludingExcess += parseFloat( salesWithExcess.toFixed(2) )

                                var detail_hash = {
                                    machineNo: `'${reportLine.machine_no}`,
                                    terminaCode: reportLine.name,
                                    businessDate:  moment(reportLine.business_date).format("MM-DD-YYYY"),
                                    beginningSi: reportLineDetails.beginningSi,
                                    endingSi: reportLineDetails.endingSi,
                                    beginningBalance: reportLineDetails.beginningGrossBalance.toFixed(2),
                                    endingBalance: reportLineDetails.endingGrossBalance.toFixed(2),

                                    grossSales: reportLineDetails.grossSales.total.toFixed(2),
                                    grossVatableSales: reportLineDetails.grossSales.vatable.toFixed(2),
                                    grossVatAmount: reportLineDetails.grossSales.vatAmount.toFixed(2),
                                    grossVatExemptSales: vat_exempt_sales,
                                    grossZeroRatedSales: reportLineDetails.grossSales.zeroRated.toFixed(2),

                                    regularDiscount: reportLineDetails.deductions.regular.toFixed(2),
                                    specialDiscount2: reportLineDetails.deductions.specialVatExemptDiscount.toFixed(2) ,
                                    specialDiscount: reportLineDetails.deductions.specialVatableDiscount.toFixed(2) ,
                                    totalReturns: reportLineDetails.deductions.returns.toFixed(2),
                                    totalVoids: reportLineDetails.deductions.void.toFixed(2),
                                    totalReplaced: reportLineDetails.deductions.manual.toFixed(2),
                                    totalDeductions: reportLineDetails.deductions.total.toFixed(2),

                                    adjustmentOnVatRegular: reportLineDetails.adjustmentsOnVat.regular.toFixed(2),
                                    adjustmentOnVatSpecial2: reportLineDetails.adjustmentsOnVat.specialVatExemptDiscount.toFixed(2),
                                    adjustmentOnVatSpecial: reportLineDetails.adjustmentsOnVat.specialVatableDiscount.toFixed(2),
                                    adjustmentOnVatReturns: reportLineDetails.adjustmentsOnVat.returns.toFixed(2),
                                    adjustmentOnVatRefund: reportLineDetails.adjustmentsOnVat.refund.toFixed(2),
                                    adjustmentOnVatVoids: reportLineDetails.adjustmentsOnVat.void.toFixed(2),
                                    adjustmentOnVatManual: reportLineDetails.adjustmentsOnVat.manual.toFixed(2),
                                    totalVatAdjustments: reportLineDetails.adjustmentsOnVat.total.toFixed(2),

                                    vatPayables: vatPayables.toFixed(2),
                                    netAmountReceived: netAmountReceived.toFixed(2),
                                    excessGC: reportLineDetails.otherIncome.excessGC.toFixed(2),
                                    excessRS: reportLineDetails.otherIncome.excessRS.toFixed(2),
                                    salesWithExcess: salesWithExcess.toFixed(2),
                                    siResetCount: reportLineDetails.siResetCount,
                                    zReadingCounter: reportLineDetails.zReadingCounter
                                }

                                this.jsonData.push(detail_hash)
                        }

                        if (this.jsonData.length == 0) {
                          continue
                        }

                        siteTotalSales += totalSales
                        siteTotalVatablesSales += totalVatablesSales
                        siteTotalVatAmount += totalVatAmount
                        siteTotalVatExemptSales += totalVatExemptSales
                        siteTotalZeroRatedSales += totalZeroRatedSales
                        siteTotalRegularDeductions += totalRegularDeductions
                        siteTotalSpecialDeductions += totalSpecialDeductions
                        siteTotalSpecialDeductions2 += totalSpecialDeductions2
                        siteTotalReturnDeductions += totalReturnDeductions
                        siteTotalVoidDeductions += totalVoidDeductions
                        siteTotalManualDeductions += totalManualDeductions
                        siteTotalDeductions2 += totalDeductions2
                        siteTotalVatAdjustmentRegular += totalVatAdjustmentRegular
                        siteTotalVatAdjustmentSpecial += totalVatAdjustmentSpecial
                        siteTotalVatAdjustmentSpecial2 += totalVatAdjustmentSpecial2
                        siteTotalVatAdjustmentReturn += totalVatAdjustmentReturn
                        siteTotalVatAdjustmentRefund += totalVatAdjustmentRefund
                        siteTotalVatAdjustmentVoid += totalVatAdjustmentVoid
                        siteTotalVatAdjustmentManual += totalVatAdjustmentManual
                        siteTotalAdjustment2 += totalAdjustment2
                        siteTotalVatPayables += totalVatPayables
                        siteTotalNetAmountReceived += totalNetAmountReceived
                        siteTotalExcessGC += totalExcessGC
                        siteTotalExcessRS += totalExcessRS
                        siteTotalSalesIncludingExcess+= totalSalesIncludingExcess

                        if(this.birCombinedReports.length > 0)
                            this.jsonData.push({machineNo : "SITE TOTAL:" , terminalCode: "" , businessDate : "" , beginningSi : "" , endingSi : "" , beginningBalance : "" , endingBalance : "" , grossSales : totalSales.toFixed(2) , grossVatableSales : totalVatablesSales.toFixed(2) , grossVatAmount : totalVatAmount.toFixed(2) , grossVatExemptSales : totalVatExemptSales.toFixed(2) , grossZeroRatedSales : totalZeroRatedSales.toFixed(2) , regularDiscount : totalRegularDeductions.toFixed(2) , specialDiscount2 : totalSpecialDeductions2.toFixed(2) , specialDiscount : totalSpecialDeductions.toFixed(2),  totalReturns : totalReturnDeductions.toFixed(2) , totalVoids : totalVoidDeductions.toFixed(2) , totalReplaced : totalManualDeductions.toFixed(2) , totalDeductions : totalDeductions2.toFixed(2) , adjustmentOnVatRegular : totalVatAdjustmentRegular.toFixed(2) , adjustmentOnVatSpecial2 : totalVatAdjustmentSpecial2.toFixed(2), adjustmentOnVatSpecial : totalVatAdjustmentSpecial.toFixed(2) , adjustmentOnVatReturns : totalVatAdjustmentReturn.toFixed(2),  adjustmentOnVatRefund : totalVatAdjustmentRefund.toFixed(2) , adjustmentOnVatVoids : totalVatAdjustmentVoid.toFixed(2) , adjustmentOnVatManual : totalVatAdjustmentManual.toFixed(2) , totalVatAdjustments : totalAdjustment2.toFixed(2) , vatPayables : totalVatPayables.toFixed(2) , netAmountReceived : totalNetAmountReceived.toFixed(2) , excessGC : totalExcessGC.toFixed(2) , excessRS : totalExcessRS.toFixed(2) , salesWithExcess : totalSalesIncludingExcess.toFixed(2) , siResetCount : "", zReadingCounter : ""})

                        if(x == (siteSpecific.length - 1)){
                            this.jsonData.push({
                                machineNo : "GRAND TOTAL: " ,
                                terminaCode: "",
                                businessDate : "",
                                beginningSi : "",
                                endingSi : "",
                                beginningBalance : "",
                                endingBalance : "",
                                grossSales : siteTotalSales.toFixed(2) ,
                                grossVatableSales : siteTotalVatablesSales.toFixed(2) ,
                                grossVatAmount : siteTotalVatAmount.toFixed(2) ,
                                grossVatExemptSales : siteTotalVatExemptSales.toFixed(2) ,
                                grossZeroRatedSales : siteTotalZeroRatedSales.toFixed(2) ,
                                regularDiscount : siteTotalRegularDeductions.toFixed(2) ,
                                specialDiscount : siteTotalSpecialDeductions.toFixed(2) ,
                                specialDiscount2 : siteTotalSpecialDeductions2.toFixed(2) ,
                                totalReturns : siteTotalReturnDeductions.toFixed(2) ,
                                totalVoids : siteTotalVoidDeductions.toFixed(2) ,
                                totalReplaced : siteTotalManualDeductions.toFixed(2) ,
                                totalDeductions : siteTotalDeductions2.toFixed(2) ,
                                adjustmentOnVatRegular : siteTotalVatAdjustmentRegular.toFixed(2) ,
                                adjustmentOnVatSpecial : siteTotalVatAdjustmentSpecial.toFixed(2) ,
                                adjustmentOnVatSpecial2 : siteTotalVatAdjustmentSpecial2.toFixed(2) ,
                                adjustmentOnVatReturns : siteTotalVatAdjustmentReturn.toFixed(2) ,
                                adjustmentOnVatRefund : siteTotalVatAdjustmentRefund.toFixed(2) ,
                                adjustmentOnVatVoids : siteTotalVatAdjustmentVoid.toFixed(2) ,
                                adjustmentOnVatManual : siteTotalVatAdjustmentManual.toFixed(2) ,
                                totalVatAdjustments : siteTotalAdjustment2.toFixed(2) ,
                                vatPayables : siteTotalVatPayables.toFixed(2) ,
                                netAmountReceived : siteTotalNetAmountReceived.toFixed(2) ,
                                excessGC : siteTotalExcessGC.toFixed(2) ,
                                excessRS : siteTotalExcessRS.toFixed(2) ,
                                salesWithExcess : siteTotalSalesIncludingExcess.toFixed(2),
                                siResetCount : "",
                                zReadingCounter : ""
                            })
                        }

                        }
                    this.spinning= false;
                    return this.jsonData;
                }else{
                    for(var x=0; x < siteSpecific.length; x++){
                        this.birCombinedReports = siteSpecific[x].report_details

                        // console.log("____!!!!_______")
                        // console.log(this.birCombinedReports)

                        for(var i=0; i < this.birCombinedReports.length; i++){
                            var reportData = this.birCombinedReports[i];
                            reportData.machine_no = `'${reportData.machine_no}`
                            reportData.site_tin = `'${siteSpecific[x].site_tin}`
                            reportData.site_name = siteSpecific[x].site_name
                            this.jsonData.push(reportData)
                        }
                    }
                    this.spinning= false;
                    return this.jsonData;
                }
            },

            formattingExportData(businessDate, detail) {
                const safe = (v) => (v == null ? 0 : v); // handles null or undefined

                const { grossSales = {}, netSales = 0, deductions = {}, adjustmentsOnVat = {}, otherIncome = {} } = detail;
                const vatPayables = safe(grossSales.vatAmount) - safe(adjustmentsOnVat.total);
                const netAmountReceived = safe(netSales);
                const salesWithExcess = netAmountReceived + safe(otherIncome.total);

                // const fmt = (n) => formatNumber(Number(n || 0).toFixed(4));
                const fmt = (n) => {
                    const num = Number(n || 0).toFixed(4);   // "44.6000"
                    const [intPart, decPart] = num.split(".");  
                    const formattedInt = Number(intPart).toLocaleString();  
                    return `${formattedInt}.${decPart}`;  
                };

                return {
                    businessDate: moment(businessDate).format("MM-DD-YYYY"),
                    beginningSi: String(
                            detail.beginningSi != null ? detail.beginningSi : 0
                        ).padStart(8, "0"),
                    endingSi: String(
                            detail.endingSi != null ? detail.endingSi : 0
                        ).padStart(8, "0"),
                    beginningBalance: fmt(detail.beginningGrossBalance),
                    endingBalance: fmt(detail.endingGrossBalance),
                    grossSales: {
                        total:     fmt(grossSales.total),
                        vatable:   fmt(grossSales.vatable),
                        vatAmount: fmt(grossSales.vatAmount),
                        vatExempt: fmt(grossSales.vatExempt),
                        zeroRated: fmt(grossSales.zeroRated),
                    },

                    // "void":  - void
                    // "total":   - total deductions
                    // "manual": 0.0,
                    // "refund":  - refund
                    // "regular":  - others
                    // "returns":  - returns
                    // "voidCount": 0,
                    // "SCDiscount5": -  SC 5%
                    // "manualCount": 0,
                    // "refundCount": 0,
                    // "PWDDiscount5":  - PWD 5%
                    // "SCDiscount20": - SC 20%
                    // "returnsCount": 0,
                    // "voidDiscount": 0.0,
                    // "PWDDiscount20": - PWD 20%
                    // "movSPDiscount": - MOV
                    // "naacSPDiscount": - NAAC
                    // "returnDiscount": - others
                    // "specialVatableDiscount": 11.0014,
                    // "specialVatExemptDiscount": 0.0,
                    // "specialTenPercentDiscount": - Solo Parent

                    deductions: {
                        regular:                      fmt(deductions.regular),
                        SCDiscount5:                  fmt(deductions.SCDiscount5),
                        SCDiscount20:                 fmt(deductions.SCDiscount20),
                        PWDDiscount20:                fmt(deductions.PWDDiscount20),
                        PWDDiscount5:                 fmt(deductions.PWDDiscount5),
                        naacSPDiscount:               fmt(deductions.naacSPDiscount),
                        movSPDiscount:                fmt(deductions.movSPDiscount),
                        specialTenPercentDiscount:    fmt(deductions.specialTenPercentDiscount),
                        specialVatableDiscount:       fmt(deductions.specialVatableDiscount),
                        specialVatExemptDiscount:     fmt(deductions.specialVatExemptDiscount),
                        returns:                      fmt(deductions.returns),
                        refund:                       fmt(deductions.refund),
                        void:                         fmt(deductions.void),
                        manual:                       fmt(deductions.manual),
                        total:                        fmt(deductions.total),
                    },

                    //   "adjustmentsOnVat": {
                    //     "void": 0,
                    //     "total": 2.49,
                    //     "manual": 0,
                    //     "refund": 0,
                    //     "regular": 1.61,
                    //     "returns": 0,
                    //     "SCDiscount": 0,
                    //     "PWDDiscount": 0,
                    //     "movSPDiscount": 0,
                    //     "naacSPDiscount": 0,
                    //     "specialVatableDiscount": 0.88,
                    //     "specialVatExemptDiscount": 0,
                    //     "specialTenPercentDiscount": 0
                    // },

                    adjustments: {
                        SCDiscount:                   fmt(adjustmentsOnVat.SCDiscount),
                        PWDDiscount:                  fmt(adjustmentsOnVat.PWDDiscount),
                        specialTenPercentDiscount:    fmt(adjustmentsOnVat.specialTenPercentDiscount),
                        regular:                      fmt(adjustmentsOnVat.regular),
                        returns:                      fmt(adjustmentsOnVat.returns),
                        refund:                       fmt(adjustmentsOnVat.refund),
                        void:                         fmt(adjustmentsOnVat.void),
                        manual:                       fmt(adjustmentsOnVat.manual),
                        total:                        fmt(adjustmentsOnVat.total),
                    },
                    manualIssuedSales: fmt(deductions.manual+ adjustmentsOnVat.manual),
                    vatPayables:       fmt(vatPayables),
                    netAmountReceived: fmt(netAmountReceived),
                    otherIncome: {
                        excessGC: fmt(otherIncome.excessGC),
                        excessRS: fmt(otherIncome.excessRS),
                        total:    fmt(otherIncome.total),
                    },
                    totalIncome: fmt(otherIncome.total + netAmountReceived),
                    salesWithExcess: fmt(salesWithExcess),
                    siResetCount:    detail.resetCounterSI || "00",
                    zReadingCounter: String(
                            detail.zReadingCounter != null ? detail.zReadingCounter : 0
                        ).padStart(5, "0")
                };
            },
            totalAllAmount(allTotal, formattedDetails) {
                // toNum: convert formatted strings like "1,234.56" or numbers to Number
                const toNum = (v) => parseFloat(String(v == null ? "0" : v).replace(/,/g, ""));
                
                console.log("formattedDetails")
                console.log(formattedDetails)

                const { grossSales = {}, deductions = {}, adjustmentsOnVat = {}, otherIncome = {} } = formattedDetails;
                let adjustments = adjustmentsOnVat
                const vatPayables = toNum(grossSales.vatAmount) - toNum(adjustments.total);
                const netAmountReceived = toNum(formattedDetails.netSales);
                const salesWithExcess = netAmountReceived + toNum(otherIncome.total);

                // Gross Sales
                allTotal.totalSales               = (allTotal.totalSales || 0) + toNum(grossSales.total);
                allTotal.totalVatablesSales       = (allTotal.totalVatablesSales || 0) + toNum(grossSales.vatable);
                allTotal.totalVatAmount           = (allTotal.totalVatAmount || 0) + toNum(grossSales.vatAmount);
                allTotal.totalVatExemptSales      = (allTotal.totalVatExemptSales || 0) + toNum(grossSales.vatExempt);
                allTotal.totalZeroRatedSales      = (allTotal.totalZeroRatedSales || 0) + toNum(grossSales.zeroRated);

                // Deductions
                allTotal.totalRegularDeductions   = (allTotal.totalRegularDeductions || 0) + toNum(deductions.regular);
                allTotal.totalSCDiscount5         = (allTotal.totalSCDiscount5 || 0) + toNum(deductions.SCDiscount5);
                allTotal.totalSCDiscount20        = (allTotal.totalSCDiscount20 || 0) + toNum(deductions.SCDiscount20);
                allTotal.totalPWDDiscount20       = (allTotal.totalPWDDiscount20 || 0) + toNum(deductions.PWDDiscount20);
                allTotal.totalPWDDiscount5        = (allTotal.totalPWDDiscount5 || 0) + toNum(deductions.PWDDiscount5);
                allTotal.totalNaacSPDiscount      = (allTotal.totalNaacSPDiscount || 0) + toNum(deductions.naacSPDiscount);
                allTotal.totalSpecialTenPercent   = (allTotal.totalSpecialTenPercent || 0) + toNum(deductions.specialTenPercentDiscount);
                allTotal.totalMovSPDiscount       = (allTotal.totalMovSPDiscount || 0) + toNum(deductions.movSPDiscount);
                allTotal.totalReturnDeductions    = (allTotal.totalReturnDeductions || 0) + toNum(deductions.returns);
                allTotal.totalRefundDeductions    = (allTotal.totalRefundDeductions || 0) + toNum(deductions.refund);
                allTotal.totalVoidDeductions      = (allTotal.totalVoidDeductions || 0) + toNum(deductions.void);
                allTotal.totalManualDeductions    = (allTotal.totalManualDeductions || 0) + toNum(deductions.manual);
                allTotal.totalDeductions2         = (allTotal.totalDeductions2 || 0) + toNum(deductions.total);

                // Adjustments
                allTotal.totalVatAdjustmentSC            = (allTotal.totalVatAdjustmentSC || 0) + toNum(adjustments.SCDiscount);
                allTotal.totalVatAdjustmentPWD           = (allTotal.totalVatAdjustmentPWD || 0) + toNum(adjustments.PWDDiscount);
                allTotal.totalVatAdjustmentSpecialTen    = (allTotal.totalVatAdjustmentSpecialTen || 0) + toNum(adjustments.specialTenPercentDiscount);
                allTotal.totalVatAdjustmentRegular       = (allTotal.totalVatAdjustmentRegular || 0) + toNum(adjustments.regular);
                allTotal.totalVatAdjustmentReturn        = (allTotal.totalVatAdjustmentReturn || 0) + toNum(adjustments.returns);
                allTotal.totalVatAdjustmentRefund        = (allTotal.totalVatAdjustmentRefund || 0) + toNum(adjustments.refund);
                allTotal.totalVatAdjustmentVoid          = (allTotal.totalVatAdjustmentVoid || 0) + toNum(adjustments.void);
                allTotal.totalVatAdjustmentManual        = (allTotal.totalVatAdjustmentManual || 0) + toNum(adjustments.manual);
                allTotal.totalAdjustment2                = (allTotal.totalAdjustment2 || 0) + toNum(adjustments.total);

                // VAT payable & net amount
                allTotal.totalVatPayables        = (allTotal.totalVatPayables || 0) + vatPayables;
                allTotal.totalNetAmountReceived  = (allTotal.totalNetAmountReceived || 0) + toNum(formattedDetails.netSales);

                // Other income
                allTotal.totalExcessGC           = (allTotal.totalExcessGC || 0) + toNum(otherIncome.excessGC);
                allTotal.totalExcessRS           = (allTotal.totalExcessRS || 0) + toNum(otherIncome.excessRS);
                allTotal.totalOtherIncome        = allTotal.totalExcessGC + allTotal.totalExcessRS
                allTotal.totalSalesIncludingExcess = (allTotal.totalSalesIncludingExcess || 0) + salesWithExcess;
                allTotal.totalIncome            = allTotal.totalNetAmountReceived + allTotal.totalOtherIncome
            },
            async generateReport(){
                // 2021-03-03
                this.spinning= true;
                if(this.selectedFormat == 2){if (!this.value[0] || !this.value[1]) {
                    this.$notification['error']({
                      message: 'Export Error',
                      description: "Date Range can't be blank. Try increasing the scope by adjusting the filters."
                    });
                    this.spinning= false;
                    return [];
                  } else {
                    this.searchDateFrom = this.value[0] ? this.value[0].startOf('month').format("YYYY-MM-DD") : '';
                    this.searchDateTo = this.value[1] ? this.value[1].endOf('month').format("YYYY-MM-DD") : '';
                    if(this.searchDateFrom == null || this.searchDateTo == null){
                        this.$notification['error']({
                        message: 'Export Error',
                        description: "Date Range can't be blank. Try increasing the scope by adjusting the filters."
                        });
                        this.spinning= false;
                        return [];
                    }
                  }
                } else {
                    if(this.searchDateFrom == null || this.searchDateTo == null){
                        this.$notification['error']({
                        message: 'Export Error',
                        description: "Date Range can't be blank. Try increasing the scope by adjusting the filters."
                        });
                        this.spinning= false;
                        return [];
                    }
                }

                var queryResult = await HTTPRequest.getRequest(this.endPoint + `z_readings/bir_combined_report_5_1?format=${this.selectedFormat}&from=` + this.searchDateFrom + "&to=" + this.searchDateTo + "&site_ids=" + this.selectedSiteId , null)

                let reportLengths = queryResult.report_details.map(a => a.report_details.length)
                console.log("reportLengths")
                console.log(reportLengths)
                let isReportsEmpty = reportLengths.every(reportLength => reportLength == 0)
                console.log("checker")
                console.log(isReportsEmpty)
                if (isReportsEmpty) {
                    this.$notification['warning']({
                    message: 'Export Error',
                    description: 'Empty data. Try increasing the scope by adjusting the filters.'
                    });
                    this.spinning= false;
                    return [];
                }
                
                if(this.selectedFormat == 1){
                    var siteSpecific = queryResult.report_details
                    var headers = [     [
                        {content: 'Machine No', rowSpan: 4, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Terminal Code', rowSpan: 4, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Business Date', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'Beginning SI No.', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'Ending SI No.', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'Grand Accum. Sales Ending', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'Grand Accum. Beg. Balance', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'Sales Issued w/ Manual SI/OR (per RR 16-2018)', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'Gross Sales for the Day', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'Vatable Sales', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'VAT Amount', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'Vat-Exempt Sales', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'Zero Rated Sales', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        
                        {content: 'Deductions', colSpan: 12, styles:{halign:'center'}},
                        {content: 'Adjustments on VAT', colSpan: 8, styles:{halign:'center'}},
                        {content: 'VAT Payables', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'Net Sales', rowSpan: 4, styles:{halign:'center', valign:'center'}},

                        {content: 'Other Income', colSpan: 3, styles:{halign:'center'}},
                        {content: 'Total Income', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'Reset Counter', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'Z-Counter', rowSpan: 4, styles:{halign:'center', valign:'center'}}
                    ],
                    [
                        {content:'Discount', colSpan:8, styles:{halign:'center'}},
                        {content:'Return', rowSpan:3, styles:{halign:'center', valign:'center'}},
                        {content:'Refund', rowSpan:3, styles:{halign:'center', valign:'center'}},
                        {content:'Void', rowSpan:3, styles:{halign:'center', valign:'center'}},
                        {content:'Total Deductions', rowSpan:3, styles:{halign:'center', valign:'center'}},

                        {content:'Discount', colSpan:4, styles:{halign:'center'}},
                        {content:'Return', rowSpan:3, styles:{halign:'center', valign:'center'}},
                        {content:'Refund', rowSpan:3, styles:{halign:'center', valign:'center'}},
                        {content:'Void', rowSpan:3, styles:{halign:'center', valign:'center'}},
                        {content:'Total Adjustments', rowSpan:3, styles:{halign:'center', valign:'center'}},

                        {content:'Excess GC', rowSpan:3, styles:{halign:'center', valign:'center'}},
                        {content:'Excess RS', rowSpan:3, styles:{halign:'center', valign:'center'}},
                        {content:'Total', rowSpan:3, styles:{halign:'center', valign:'center'}}
                    ],
                    [
                        {content:'SC', colSpan:2, styles:{halign:'center'}},
                        {content:'PWD', colSpan:2, styles:{halign:'center'}},
                        {content:'NAAC', rowSpan:2, styles:{halign:'center', valign:'center'}},
                        {content:'Solo Parent', rowSpan:2, styles:{halign:'center', valign:'center'}},
                        {content:'MOV', rowSpan:2, styles:{halign:'center', valign:'center'}},
                        {content:'Others', rowSpan:2, styles:{halign:'center', valign:'center'}},

                        {content:'Regular', rowSpan:2, styles:{halign:'center', valign:'center'}},
                        {content:'Special (5%)', rowSpan:2, styles:{halign:'center', valign:'center'}},
                        {content:'Special (20%)', rowSpan:2, styles:{halign:'center', valign:'center'}},
                        {content:'Others', rowSpan:2, styles:{halign:'center', valign:'center'}}
                    ],
                    [
                        {content:'5%', styles:{halign:'center'}},
                        {content:'20%', styles:{halign:'center'}},
                        {content:'5%', styles:{halign:'center'}},
                        {content:'20%', styles:{halign:'center'}}
                    ]
                              ];

                    var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: [615, 1770] });

                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    var siteTotalSales = 0 ,siteTotalVatablesSales = 0 ,siteTotalVatAmount = 0 ,siteTotalVatExemptSales = 0 ,siteTotalZeroRatedSales = 0 ,siteTotalRegularDeductions = 0 ,siteTotalSpecialDeductions = 0 ,siteTotalReturnDeductions = 0 ,siteTotalVoidDeductions = 0 ,siteTotalManualDeductions = 0 ,siteTotalDeductions2 = 0 ,siteTotalVatAdjustmentRegular = 0 ,siteTotalVatAdjustmentSpecial = 0 ,siteTotalVatAdjustmentReturn = 0 , siteTotalVatAdjustmentRefund = 0,siteTotalVatAdjustmentVoid = 0 ,siteTotalVatAdjustmentManual = 0 ,siteTotalAdjustment2 = 0 ,siteTotalVatPayables = 0 ,siteTotalNetAmountReceived = 0 ,siteTotalExcessGC = 0 ,siteTotalExcessRS = 0 ,siteTotalSalesIncludingExcess= 0, siteTotalVatAdjustmentSpecial2= 0, siteTotalSpecialDeductions2 = 0;

                    for(var x=0; x < siteSpecific.length; x++){
                        this.birCombinedReports = siteSpecific[x].report_details

                        if(x > 0 ){
                            doc.addPage();
                        }

                        var reportData = [];
                        var totalSales =0, totalVatablesSales =0, totalVatAmount =0, totalVatExemptSales =0, totalZeroRatedSales =0, totalRegularDeductions =0, totalSpecialDeductions =0, totalSpecialDeductions2 = 0,
                            totalReturnDeductions =0, totalVoidDeductions =0, totalManualDeductions =0, totalDeductions2 =0, totalVatAdjustmentRegular =0,
                            totalVatAdjustmentSpecial =0,totalVatAdjustmentSpecial2 =0,  totalVatAdjustmentReturn =0, totalVatAdjustmentVoid =0, totalVatAdjustmentManual =0, totalAdjustment2 =0,
                            totalVatPayables =0, totalNetAmountReceived =0, totalExcessGC =0, totalExcessRS =0, totalSalesIncludingExcess=0;

                    let allTotal = {};

                    for(var i=0; i < this.birCombinedReports.length; i++){
                        var reportLine = this.birCombinedReports[i]
                        var reportLineDetails = JSON.parse(reportLine.reading_details)

                        this.totalAllAmount(allTotal, reportLineDetails);

                        const formattedDetails = this.formattingExportData(reportLine.business_date, reportLineDetails);
                        const { grossSales, deductions, adjustments, otherIncome } = formattedDetails;

                        console.log("Report Line")
                        console.log(reportLine)
                        
                        const detail = [
                            // Main (1–11)
                            reportLine.machine_no,
                            reportLine.code,
                            formattedDetails.businessDate,
                            formattedDetails.beginningSi,
                            formattedDetails.endingSi,
                            formattedDetails.endingBalance,
                            formattedDetails.beginningBalance,
                            formattedDetails.manualIssuedSales,
                            grossSales.total,
                            grossSales.vatable,
                            grossSales.vatAmount,
                            grossSales.vatExempt,
                            grossSales.zeroRated,

                            // Deductions → Discount (12–19)
                            deductions.SCDiscount5,
                            deductions.SCDiscount20,
                            deductions.PWDDiscount5,
                            deductions.PWDDiscount20,
                            deductions.naacSPDiscount,
                            deductions.specialTenPercentDiscount,
                            deductions.movSPDiscount,
                            deductions.regular,          // << you previously put regular, incorrect

                            // Deductions → Others (20–23)
                            deductions.returns,
                            deductions.refund,
                            deductions.void,
                            deductions.total,

                            // Adjustments on VAT → Discount (24–27)
                            adjustments.SCDiscount,
                            adjustments.PWDDiscount,
                            adjustments.specialTenPercentDiscount,
                            adjustments.regular,         // < previously wrong

                            // Adjustments on VAT → Others (28–31)
                            adjustments.returns,
                            adjustments.refund,
                            adjustments.void,
                            adjustments.total,

                            // 32–33
                            formattedDetails.vatPayables,
                            formattedDetails.netAmountReceived,

                            // Other Income (34–36)
                            otherIncome.excessGC,
                            otherIncome.excessRS,
                            otherIncome.total,

                            //Total Income
                            formattedDetails.totalIncome,

                            // 37–38
                            formattedDetails.siResetCount,
                            formattedDetails.zReadingCounter
                        ];



                        reportData.push(Object.assign({}, detail))
                    }

                    if (reportData.length == 0) {
                        var pageCount = doc.internal.getNumberOfPages();
                        doc.deletePage(pageCount)
                        continue;
                    }

                        // Convert formatted string → number
                    const toNum = (v) =>
                        parseFloat(String(v == null || v === "" ? "0" : v).replace(/,/g, ""));

                    // Convert number → formatted string (no commas in decimal part)
                    const toStr = (v) => {
                        const num = Number(v || 0);
                        const fixed = num.toFixed(4);
                        const [i, d] = fixed.split(".");
                        return `${Number(i).toLocaleString()}.${d}`;
                    };

                    // Final totals cleanup (safe)
                    for (const key in allTotal) {
                        const numericValue = toNum(allTotal[key]);
                        allTotal[key] = toStr(numericValue);
                    }


                    console.log("allTotal")
                    console.log(allTotal)

                    if(x == (siteSpecific.length - 1)){
                      // Input total values
                      reportData.push([
                        "TOTAL:",
                        '', '','', '', '', '', '', // Main
                        allTotal.totalSales,
                        allTotal.totalVatablesSales,
                        allTotal.totalVatAmount,
                        allTotal.totalVatExemptSales,
                        allTotal.totalZeroRatedSales,
                        allTotal.totalSCDiscount5,
                        allTotal.totalSCDiscount20,
                        allTotal.totalPWDDiscount5,
                        allTotal.totalPWDDiscount20,
                        allTotal.totalNaacSPDiscount,
                        allTotal.totalSpecialTenPercent,
                        allTotal.totalMovSPDiscount,
                        allTotal.totalRegularDeductions,
                        allTotal.totalReturnDeductions,
                        allTotal.totalRefundDeductions,
                        allTotal.totalVoidDeductions,
                        allTotal.totalDeductions2,

                       
                        allTotal.totalVatAdjustmentSC,  //For checking
                        allTotal.totalVatAdjustmentPWD, //For checking
                        allTotal.totalVatAdjustmentSpecialTen,
                        allTotal.totalVatAdjustmentRegular,

                        allTotal.totalVatAdjustmentReturn,
                        allTotal.totalVatAdjustmentRefund,
                        allTotal.totalVatAdjustmentVoid,
                        allTotal.totalAdjustment2,
                        
                        allTotal.totalVatPayables,
                        allTotal.totalNetAmountReceived,

                        allTotal.totalExcessGC,
                        allTotal.totalExcessRS,
                        allTotal.totalOtherIncome,
                        allTotal.totalIncome,

                        '', '' // Reset & Z Counter (or you can sum if needed)
                    ]);

                    }

                        // siteTotalSales += totalSales
                        // siteTotalVatablesSales += totalVatablesSales
                        // siteTotalVatAmount += totalVatAmount
                        // siteTotalVatExemptSales += totalVatExemptSales
                        // siteTotalZeroRatedSales += totalZeroRatedSales
                        // siteTotalRegularDeductions += totalRegularDeductions
                        // siteTotalSpecialDeductions += totalSpecialDeductions
                        // siteTotalSpecialDeductions2 += totalSpecialDeductions2
                        // siteTotalReturnDeductions += totalReturnDeductions
                        // siteTotalVoidDeductions += totalVoidDeductions
                        // siteTotalManualDeductions += totalManualDeductions
                        // siteTotalDeductions2 += totalDeductions2
                        // siteTotalVatAdjustmentRegular += totalVatAdjustmentRegular
                        // siteTotalVatAdjustmentSpecial += totalVatAdjustmentSpecial
                        // siteTotalVatAdjustmentSpecial2 += totalVatAdjustmentSpecial2
                        // siteTotalVatAdjustmentReturn += totalVatAdjustmentReturn
                        // siteTotalVatAdjustmentVoid += totalVatAdjustmentVoid
                        // siteTotalVatAdjustmentManual += totalVatAdjustmentManual
                        // siteTotalAdjustment2 += totalAdjustment2
                        // siteTotalVatPayables += totalVatPayables
                        // siteTotalNetAmountReceived += totalNetAmountReceived
                        // siteTotalExcessGC += totalExcessGC
                        // siteTotalExcessRS += totalExcessRS
                        // siteTotalSalesIncludingExcess+= totalSalesIncludingExcess

                        // reportData.push(Object.assign({}, ["SITETOTAL: ", "", "", "", "", "", "", formatNumber(totalSales.toFixed(2)), formatNumber(totalVatablesSales.toFixed(2)), formatNumber(totalVatAmount.toFixed(2)), formatNumber(totalVatExemptSales.toFixed(2)), formatNumber(totalZeroRatedSales.toFixed(2)), formatNumber(totalRegularDeductions.toFixed(2)), formatNumber(totalSpecialDeductions.toFixed(2)), formatNumber(totalSpecialDeductions2.toFixed(2)), formatNumber(totalReturnDeductions.toFixed(2)), formatNumber(totalVoidDeductions.toFixed(2)), formatNumber(totalManualDeductions.toFixed(2)), formatNumber(totalDeductions2.toFixed(2)), formatNumber(totalVatAdjustmentRegular.toFixed(2)), formatNumber(totalVatAdjustmentSpecial.toFixed(2)), formatNumber(totalVatAdjustmentSpecial2.toFixed(2)), formatNumber(totalVatAdjustmentReturn.toFixed(2)), formatNumber(totalVatAdjustmentVoid.toFixed(2)), formatNumber(totalVatAdjustmentManual.toFixed(2)), formatNumber(totalAdjustment2.toFixed(2)), formatNumber(totalVatPayables.toFixed(2)), formatNumber(totalNetAmountReceived.toFixed(2)), formatNumber(totalExcessGC.toFixed(2)), formatNumber(totalExcessRS.toFixed(2)), formatNumber(totalSalesIncludingExcess.toFixed(2)), "", ""]))

                        // if(x == (siteSpecific.length - 1)){
                        //     reportData.push(Object.assign({}, ["GRAND TOTAL: ", "", "", "", "", "", "", formatNumber(siteTotalSales.toFixed(2)), formatNumber(siteTotalVatablesSales.toFixed(2)), formatNumber(siteTotalVatAmount.toFixed(2)), formatNumber(siteTotalVatExemptSales.toFixed(2)), formatNumber(siteTotalZeroRatedSales.toFixed(2)), formatNumber(siteTotalRegularDeductions.toFixed(2)), formatNumber(siteTotalSpecialDeductions.toFixed(2)), formatNumber(siteTotalSpecialDeductions2.toFixed(2)), formatNumber(siteTotalReturnDeductions.toFixed(2)), formatNumber(siteTotalVoidDeductions.toFixed(2)), formatNumber(siteTotalManualDeductions.toFixed(2)), formatNumber(siteTotalDeductions2.toFixed(2)), formatNumber(siteTotalVatAdjustmentRegular.toFixed(2)), formatNumber(siteTotalVatAdjustmentSpecial.toFixed(2)), formatNumber(siteTotalVatAdjustmentSpecial2.toFixed(2)), formatNumber(siteTotalVatAdjustmentReturn.toFixed(2)), formatNumber(siteTotalVatAdjustmentVoid.toFixed(2)), formatNumber(siteTotalVatAdjustmentManual.toFixed(2)), formatNumber(siteTotalAdjustment2.toFixed(2)), formatNumber(siteTotalVatPayables.toFixed(2)), formatNumber(siteTotalNetAmountReceived.toFixed(2)), formatNumber(siteTotalExcessGC.toFixed(2)), formatNumber(siteTotalExcessRS.toFixed(2)), formatNumber(siteTotalSalesIncludingExcess.toFixed(2)), "", ""]))
                        // }

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"BIR Consolidated Report")
                        doc.setFontSize(12);
                        doc.text(15, 25,
                            siteSpecific && siteSpecific[0] && siteSpecific[0].site_company
                                ? siteSpecific[0].site_company
                                : ''
                            );

                            doc.text(15, 30,
                            siteSpecific && siteSpecific[0] &&
                            siteSpecific[0].site_tin && siteSpecific[0].site_tin_branch_code
                                ? siteSpecific[0].site_tin + '-' + siteSpecific[0].site_tin_branch_code
                                : ''
                            );

                            doc.text(15, 35,
                            siteSpecific && siteSpecific[0] && siteSpecific[0].site_address
                                ? siteSpecific[0].site_address
                                : ''
                            );

                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        // doc.text(15,30,"Company: " + siteSpecific[x].site_company)
                        // doc.text(15,35,"TIN: " + siteSpecific[x].site_tin)
                        // doc.text(15,45,"Address: " + siteSpecific[x].site_address)
                        doc.text(15,45,"Software: Barter POS Version 5.1")
                        // doc.text(15,50,"Serial Number: " + siteSpecific[x].serial_number)
                        // doc.text(15,55,"Machine Number: " + siteSpecific[x].machine_number)
                        // doc.text(15,60,"POS Terminal Number: " + siteSpecific[x].pos_terminal_number)
                        
                        // doc.text(15,70,"Permit Number:  " + siteSpecific[x].permit_number)

                        if( this.searchDateFrom == this.searchDateTo){
                                doc.text(15,50,"Date: " +  moment(this.searchDateFrom).format(this.dateFormat) )
                        } else {
                            doc.text(15,50,"Date Range: From " + moment(this.searchDateFrom).format(this.dateFormat)  + " to " + moment(this.searchDateTo).format(this.dateFormat))
                        }

                        doc.text(
                            140,
                            45,
                            siteSpecific && siteSpecific[0] && siteSpecific[0].site_refcode
                                ? "Branch Code: " + siteSpecific[0].site_refcode
                                : "Branch Code: -"
                            );

                        doc.text(
                            140,
                            50,
                            siteSpecific && siteSpecific[0] && siteSpecific[0].site_name
                                ? "Branch Name: " + siteSpecific[0].site_name
                                : "Branch Name: -"
                            );

                        // doc.text(140,55,"PTUSM Number: " + siteSpecific[x].permit_number)
                        // doc.text(140,60,"Accreditation Number: " + siteSpecific[x].acrreditation_number)
                        // doc.text(140,65,"Cashier ID: " + siteSpecific[x].user_name)

                        // let address = ''
                        // if(siteSpecific[x].site_address != null){
                        //     address = siteSpecific[x].site_address
                        // }
                        // doc.text(15,35, address)

                        // doc.setFontType("normal");
                        // doc.setFontSize(10);
                        // // doc.text(15,30,"Company: " + siteSpecific[x].site_company)
                        // // doc.text(15,35,"TIN: " + siteSpecific[x].site_tin)
                        // // doc.text(15,45,"Address: " + siteSpecific[x].site_address)
                        // doc.text(15,45,"Software: Barter POS Version 5.0")
                        // doc.text(15,50,"Branch: " + siteSpecific[x].site_name)

                        // if( this.searchDateFrom == this.searchDateTo){
                        //         doc.text(15,55,"Date: " +  moment(this.searchDateFrom).format(this.dateFormat) )
                        // } else {
                        //     doc.text(15,55,"Date Range: From " + moment(this.searchDateFrom).format(this.dateFormat)  + " to " + moment(this.searchDateTo).format(this.dateFormat))
                        // }

                        doc.autoTable(
                            {
                                startY: 80,
                                head: headers,
                                body: reportData,
                                theme: 'plain',
                                styles: {
                                    cellPadding: 0.5, fontSize: 7,
                                    lineWidth: 0.05,
                                    halign: 'right'
                                },
                                headStyles: {
                                    lineWidth: 0.05,
                                    cellPadding: 2,
                                    overflow: 'linebreak',
                                },
                                columnStyles: {
                                    0: {halign: "center"},
                                    1: {halign: "center"},
                                    2: {halign: "center"},
                                    3: {halign: "center"},
                                    5: {halign: "center", cellWidth: 20},
                                    6: {halign: "center", cellWidth: 20},
                                    7: {halign: "center", cellWidth: 20},
                                    8: {halign: "center", cellWidth: 20},
                                    28: {halign: "center"},
                                    29: {halign: "center"},
                                }
                            }
                        );

                        doc.setFontSize(8);
                        doc.text(15,230,"Printed By: " + secureStorage.getItem("email"))
                        doc.text(600,230,"BIR Consolidated Report", "right")
                        doc.text(15,235,"Print Date: " + moment().format(this.dateFormat2))
                        doc.text(600,235,"Page " + ( x + 1)  + " of " + siteSpecific.length, "right")
                        }

                    // let dataSrc = doc.output("datauristring");
                    // let win = window.open("", "myWindow");
                    // win.document.write("<html><head><title>jsPDF</title></head><body><embed src=" +
                    //     dataSrc + "></embed></body></html>");

                    //doc.output('dataurlnewwindow');

                    window.open(URL.createObjectURL(doc.output("blob")))
                } else{

                    var siteSpecific = queryResult.report_details

                    var headers = [
                                    [

                                        {content: 'Terminal Name'},
                                        {content: 'TIN'},
                                        {content: 'TIN Branch Code'},
                                        {content: 'Branch'},
                                        {content: 'Month'},
                                        {content: 'Year'},
                                        {content: 'MIN'},
                                        {content: 'Last OR'},
                                        {content: 'Vatable Sales'},
                                        {content: 'VAT Zero Rated Sales'},
                                        {content: 'VAT Exempt Sales'},
                                        {content: 'Other Taxes'},
                                        {content: 'VAT Amount'},
                                        {content: 'NET Sales'}

                                    ]
                              ];

                    var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                    for(let x=0; x < siteSpecific.length; x++){

                        this.birSalesReports = siteSpecific[x].report_details

                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];

                        if(this.birSalesReports.length > 0){
                            for(let i=0; i < this.birSalesReports.length; i++){

                                let element = this.birSalesReports[i];
                                let detail = [
                                        element.terminal_name,
                                        `'${siteSpecific[x].site_tin}`,
                                        siteSpecific[x].site_tin_branch_code,
                                        siteSpecific[x].site_name,
                                        element.month,
                                        element.year,
                                        element.machine_no,
                                        element.last_or,
                                        formatNumber(element.vatable_sales.toFixed(2)),
                                        formatNumber(element.zero_rated_sales),
                                        formatNumber(element.vat_exempt_sales),
                                        formatNumber(element.other_taxes),
                                        formatNumber(element.vat_amount.toFixed(2)),
                                        formatNumber(element.net_sales.toFixed(2))
                                    ]
                                reportData.push(Object.assign({}, detail))

                            }
                        }

                        if (reportData.length == 0) {
                            var pageCount = doc.internal.getNumberOfPages();
                            doc.deletePage(pageCount);
                            continue;
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"BIR Consolidated Report")
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        doc.text(300,20, siteSpecific[x].site_name);
                        doc.text(15,25,"For the Period of " + this.value[0].format('YYYY-MM')  + " to " + this.value[1].format('YYYY-MM') )

                        doc.autoTable({
                            startY: 40,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                // lineWidth: 0.25,
                                cellPadding: 3
                            },
                            styles: {
                                lineWidth: 0.25,
                                cellPadding: 1.0,
                                fontSize: 10,
                                halign: 'right'
                            },
                            columnStyles: {
                                0: {cellWidth: 30},
                                1: {cellWidth: 30},
                                2: {cellWidth: 20},
                                3: {cellWidth: 18},
                                4: {cellWidth: 18},
                                5: {cellWidth: 25},
                                6: {cellWidth: 15},
                                7: {cellWidth: 25},
                                8: {cellWidth: 25},
                                9: {cellWidth: 25},
                                10: {cellWidth: 25},
                                11: {cellWidth: 25},
                                12: {cellWidth: 25},
                                13: {cellWidth: 25},
                            }
                        });

                        doc.text(15,200,"Printed By: " + secureStorage.getItem("email"))
                        doc.text(340,200,"BIR Consolidated Report", "right")

                        doc.text(15,205,"Print Date: " + moment().format("MM/DD/YYYY hh:mm:ssA"))
                        doc.text(340,205,"Page " + ( x + 1)  + " of " + siteSpecific.length, "right")
                        window.open(URL.createObjectURL(doc.output("blob")))
                    }

                }
        this.spinning= false;
        },
async excelData() {
              this.spinning= true;

              if(this.searchDateFrom == null || this.searchDateTo == null || this.selectedTerminalId == ''){
                    this.$notification['error']({
                        message: 'Export Error',
                        description: 'Please make sure to check your current filters.'
                    });
                    this.spinning= false;
                    return
                }

              this.jsonData = [];

              const url = `${this.endPoint}z_readings/bir_combined_report?format=${this.selectedFormat}&from=` + this.searchDateFrom + "&to=" + this.searchDateTo + "&site_ids=" + this.selectedSiteId

             //  const url = `${this.endPoint}z_readings/bir_sales_report?from=${this.searchDateFrom}&to=${this.searchDateTo}&terminal_id=${this.selectedTerminalId}`
              const queryResult = await HTTPRequest.getRequest(url, null)

              if (queryResult.report_details[0].report_details.length == 0) {
                    this.$notification['warning']({
                    message: 'Export Error',
                    description: 'Empty data. Try increasing the scope by adjusting the filters.'
                    });
                    this.spinning= false;
                    return [];
                }
              const terminalZReadings = queryResult.report_details || []

              console.log("terminalZReadings")
              console.log(terminalZReadings)

              terminalZReadings.map(terminalZReading => {
                const zReadings = terminalZReading.report_details;
                const allTotal = {}

                console.log(">>> ZReading")
                console.log(terminalZReading)

                zReadings.map(zReading => {
                  const zReadingDetails = JSON.parse(zReading.reading_details);

                  this.totalAllAmount(allTotal, zReadingDetails);

                  const formattedDetails = this.formattingExportData(zReading.business_date, zReadingDetails);
                  const { grossSales, deductions, adjustments, otherIncome } = formattedDetails;

                  this.jsonData.push({
                    machineNo: zReading.machine_no,
                    terminalCode: zReading.code,
                    businessDate: formattedDetails.businessDate,
                    beginningSi: formattedDetails.beginningSi,
                    endingSi: formattedDetails.endingSi,

                    // Balances
                    beginningBalance: formattedDetails.beginningBalance,
                    endingBalance: formattedDetails.endingBalance,

                    // Manual
                    salesIssuedManual: formattedDetails.manualIssuedSales,

                    // Gross Sales
                    grossSales: grossSales.total,
                    grossVatableSales: grossSales.vatable,
                    grossVatAmount: grossSales.vatAmount,
                    grossVatExemptSales: grossSales.vatExempt,
                    grossZeroRatedSales: grossSales.zeroRated,

                    // Deductions
                    SCDiscount5:               deductions.SCDiscount5,              
                    SCDiscount20:              deductions.SCDiscount20,             
                    PWDDiscount20:             deductions.PWDDiscount20,            
                    PWDDiscount5:              deductions.PWDDiscount5,             
                    naacSPDiscount:            deductions.naacSPDiscount,           
                    specialTenPercentDiscount: deductions.specialTenPercentDiscount,
                    movSPDiscount:             deductions.movSPDiscount,            
                    regularDiscount:           deductions.regular,
                    totalReturns:              deductions.returns,
                    totalRefund:               deductions.refund,
                    totalVoids:                deductions.void, 
                    totalDeductions:           deductions.total,

                    // AdjustmentsOnVat
                    SCDiscount:                 adjustments.SCDiscount,                              
                    PWDDiscount:                adjustments.PWDDiscount,                            
                    adjSpecialTenPercentDiscount:  adjustments.specialTenPercentDiscount,
                    adjustmentOnVatRegular: adjustments.regular,
                    adjustmentOnVatReturns: adjustments.returns,
                    adjustmentOnVatRefund: adjustments.refund,
                    adjustmentOnVatVoids: adjustments.void,
                    // adjustmentOnVatManual: adjustments.manual,
                    totalVatAdjustments: adjustments.total,

                    // Vat Payables & Net Amount Received
                    vatPayables: formattedDetails.vatPayables,
                    netAmountReceived: formattedDetails.netAmountReceived,

                    // Other Income
                    excessGC: otherIncome.excessGC,
                    excessRS: otherIncome.excessRS,
                    otherIncomeTotal: otherIncome.total,
          
                    // Other data
                    totalIncome: formattedDetails.totalIncome,
                    siResetCount: formattedDetails.siResetCount,
                    zReadingCounter: formattedDetails.zReadingCounter,
                  })
                }) // zReadings map loop

                //for (const key in allTotal) { allTotal[key] = formatNumber((parseFloat(allTotal[key]) || 0.00).toFixed(4)); }
                
                // Convert formatted string → number
                const toNum = (v) =>
                    parseFloat(String(v == null || v === "" ? "0" : v).replace(/,/g, ""));

                // Convert number → formatted string (no commas in decimal part)
                const toStr = (v) => {
                    const num = Number(v || 0);
                    const fixed = num.toFixed(4);
                    const [i, d] = fixed.split(".");
                    return `${Number(i).toLocaleString()}.${d}`;
                };

                // Final totals cleanup (safe)
                for (const key in allTotal) {
                    const numericValue = toNum(allTotal[key]);
                    allTotal[key] = toStr(numericValue);
                }

                // Input total values
                this.jsonData.push({
                  machineNo: "TOTAL:",
                  terminalCode: '',
                  businessDate: '',
                  beginningSi: '',
                  endingSi: '',

                  // Balances
                  beginningBalance: '',
                  endingBalance: '',
                  salesIssuedManual: '',

                  // Gross Sales
                  grossSales: allTotal.totalSales,
                  grossVatableSales: allTotal.totalVatablesSales,
                  grossVatAmount: allTotal.totalVatAmount,
                  grossVatExemptSales: allTotal.totalVatExemptSales,
                  grossZeroRatedSales: allTotal.totalZeroRatedSales,

                  // Deductions
                  SCDiscount5:               allTotal.totalSCDiscount5,              
                  SCDiscount20:              allTotal.totalSCDiscount5,            
                  PWDDiscount20:             allTotal.totalPWDDiscount20,            
                  PWDDiscount5:              allTotal.totalPWDDiscount5,             
                  naacSPDiscount:            allTotal.totalNaacSPDiscount,         
                  specialTenPercentDiscount: allTotal.totalSpecialTenPercent,
                  movSPDiscount:             allTotal.totalMovSPDiscount,           
                  regularDiscount:           allTotal.totalRegularDeductions,
                  totalReturns:              allTotal.totalReturnDeductions,
                  totalRefund:               allTotal.totalRefundDeductions,
                  totalVoids:                allTotal.totalVoidDeductions,
                  totalDeductions:           allTotal.totalDeductions2,

    
                  SCDiscount:                 allTotal.totalVatAdjustmentSC,                              
                  PWDDiscount:                allTotal.totalVatAdjustmentPWD,                        
                  specialTenPercentDiscount:  allTotal.totalVatAdjustmentSpecialTen,
                  adjustmentOnVatRegular: allTotal.totalVatAdjustmentRegular,
                  adjustmentOnVatReturns: allTotal.totalVatAdjustmentReturn,
                  adjustmentOnVatRefund: allTotal.totalVatAdjustmentRefund,
                  adjustmentOnVatVoids: allTotal.totalVatAdjustmentVoid,
                //   adjustmentOnVatManual: allTotal.totalVatAdjustmentManual,
                  totalVatAdjustments: allTotal.totalAdjustment2,

                  // Vat Payables & Net Amount Received
                  vatPayables: allTotal.totalVatPayables,
                  netAmountReceived: allTotal.totalNetAmountReceived,

                  // Other Income
                  excessGC: allTotal.totalExcessGC,
                  excessRS: allTotal.totalExcessRS,
                  otherIncomeTotal: allTotal.totalOtherIncome,

                  totalIncome: allTotal.totalIncome,
                
                  // Other data
                  // salesWithExcess: allTotal.totalSalesIncludingExcess,
                  siResetCount: '',
                  zReadingCounter: '',
                })
              }) // terminalZReadings map loop
              this.spinning= false;
              return {records: this.jsonData, base: terminalZReadings};
            },
async generateBIRExcel() {
    const main_data = await this.excelData();

    let data = main_data["records"];
    let base = (main_data["base"] && main_data["base"][0]) ? main_data["base"][0] : {};

    if (!data || data.length === 0) return;

    // ======================
    // CONFIG
    // ======================
    const TOTAL_COLS = 40;          // was 38
    const HALF = Math.floor(TOTAL_COLS / 2); // 20
    const RIGHT_START = HALF;

    // ======================
    // 1. HEADER
    // ======================
    const header = [

        // Row 0
        [
            "Machine Number", "Terminal Code",
            "Business Date", "Beginning SI No.", "Ending SI No",
            "Grand Accum. Sales Ending", "Grand Accum. Beg. Balance",
            "Sales Issued w/ Manual SI/OR (per RR 16-2018)",
            "Gross Sales for the Day", "Vatable Sales", "VAT Amount",
            "Vat-Exempt Sales", "Zero Rated Sales",
            "Deductions", "", "", "", "", "", "", "", "", "", "", "",
            "Adjustments on VAT", "", "", "", "", "", "", "", 
            "VAT Payables", "Net Sales",
            "Other Income", "", "",
            "Total Income", "Reset Counter", "Z-Counter"
        ],

        // Row 1
        [
            "", "",
            "", "", "", "", "", "", "", "", "", "", "",
            "Discount", "", "", "", "", "", "", "",
            "Return", "Refund", "Void", "Total Deductions",
            "Discount", "", "", "",
            "Return", "Refund", "Void", "Total Adjustments",
            "", "",
            "Excess GC", "Excess RS", "Total",
            "", "", ""
        ],

        // Row 2
        [
            "", "",
            "", "", "", "", "", "", "", "", "", "", "",
            "SC", "", 
            "PWD", "", 
            "NAAC", "Solo Parent", "MOV", "Others",
            "", "", "", "",
            "Regular", "Special (5%)", "Special (20%)", "Others",
            "", "", "", "",
            "", "", 
            "", "","",
            "", "", ""
        ],

        // Row 3
        [
            "", "",
            "", "", "", "", "", "", "", "", "", "", "",
            "5%", "20%", "5%", "20%", 
            "", "", "", "",
            "", "", "", "",
            "", "", "", "",
            "", "", "", "",
            "", "", 
            "", "", "",
            "", "", ""
        ]
    ];

    // ======================
    // 2. MERGES
    // ======================
    const merges = [

        // Fixed columns (row-span)
        { s:{r:0,c:0}, e:{r:3,c:0} }, // Machine Number
        { s:{r:0,c:1}, e:{r:3,c:1} }, // Terminal Code
        { s:{r:0,c:2}, e:{r:3,c:2} }, // Business Date
        { s:{r:0,c:3}, e:{r:3,c:3} }, // Beginning SI No
        { s:{r:0,c:4}, e:{r:3,c:4} }, // Ending SI No
        { s:{r:0,c:5}, e:{r:3,c:5} }, // Grand Accum. Sales Ending
        { s:{r:0,c:6}, e:{r:3,c:6} }, //Grand Accum. Beg. Balance
        { s:{r:0,c:7}, e:{r:3,c:7} }, //Sales Issued w/ Manual SI/OR (per RR 16-2018)
        { s:{r:0,c:8}, e:{r:3,c:8} }, //Gross Sales for the Day
        { s:{r:0,c:9}, e:{r:3,c:9} }, // Vatable Sales
        { s:{r:0,c:10}, e:{r:3,c:10} }, //VAT Amount
        { s:{r:0,c:11}, e:{r:3,c:11} }, // Vat-Exempt Sales
        { s:{r:0,c:12}, e:{r:3,c:12} }, // Zero Rated Sales

        // Row 0 groups
        { s:{r:0,c:13}, e:{r:0,c:24} }, // Deductions
        { s:{r:0,c:25}, e:{r:0,c:32} }, // Adjustments
        { s:{r:0,c:33}, e:{r:3,c:33} }, // VAT Payables
        { s:{r:0,c:34}, e:{r:3,c:34} }, // Net Sales
        { s:{r:0,c:35}, e:{r:0,c:37} }, // Other Income
        { s:{r:0,c:38}, e:{r:3,c:38} }, // Total Income
        { s:{r:0,c:39}, e:{r:3,c:39} }, // Reset
        { s:{r:0,c:40}, e:{r:3,c:40} },  // Z Counter

        // Row 1 groups
        { s:{r:1,c:13}, e:{r:1,c:20} }, // Deductions - Discount group
        { s:{r:1,c:25}, e:{r:1,c:28} }, // Adjustments on VAT - Discount group
        { s:{r:1,c:21}, e:{r:3,c:21} }, // Deduction - Return
        { s:{r:1,c:22}, e:{r:3,c:22} }, // Deduction - Refund
        { s:{r:1,c:23}, e:{r:3,c:23} }, // Deduction - Void
        { s:{r:1,c:24}, e:{r:3,c:24} }, // Deduction - Total
        { s:{r:1,c:29}, e:{r:3,c:29} }, // AOV - Return
        { s:{r:1,c:30}, e:{r:3,c:30} }, // AOV - Refund
        { s:{r:1,c:31}, e:{r:3,c:31} }, // AOV - Void
        { s:{r:1,c:32}, e:{r:3,c:32} }, // AOV - Total
        { s:{r:1,c:35}, e:{r:3,c:35} }, // Other Income - Excess GC
        { s:{r:1,c:36}, e:{r:3,c:36} }, // Other Income - Excess RS
        { s:{r:1,c:37}, e:{r:3,c:37} }, // Other Income - Excess Total

        // Row 2 groups
        { s:{r:2,c:13}, e:{r:2,c:14} }, // Deductions - Discount - SC Group
        { s:{r:2,c:15}, e:{r:2,c:16} }, // Deductions - Discount - PWD Group
        { s:{r:2,c:17}, e:{r:3,c:17} }, // Deductions - Discount - NAAC
        { s:{r:2,c:18}, e:{r:3,c:18} }, // Deductions - Discount - Solo Parent
        { s:{r:2,c:19}, e:{r:3,c:19} }, // Deductions - Discount - MOV
        { s:{r:2,c:20}, e:{r:3,c:20} }, // Deductions - Discount - Others
        { s:{r:2,c:25}, e:{r:3,c:25} }, // AOV - Discount - Regular
        { s:{r:2,c:26}, e:{r:3,c:26} }, // AOV - Discount - Special 5%
        { s:{r:2,c:27}, e:{r:3,c:27} }, // AOV - Discount - Special 20%
        { s:{r:2,c:28}, e:{r:3,c:28} }, // AOV - Discount - Others
    ];


    // ======================
    // 3. DATA ROWS
    // ======================
    // console.log(">> DEBUG")
    // console.log(data)

    const rows = data.map(r => [
        r.machineNo || "",
        r.terminalCode || "",
        r.businessDate,
        r.beginningSi,
        r.endingSi,
        r.endingBalance,
        r.beginningBalance,
        r.salesIssuedManual,
        r.grossSales,
        r.grossVatableSales,
        r.grossVatAmount,
        r.grossVatExemptSales,
        r.grossZeroRatedSales,

        // Deductions
            // Deductions - Discount
                // Deductions - Discount - SC
                    r.SCDiscount5,
                    r.SCDiscount20,
                // Deductions - Discount - PWD
                    r.PWDDiscount5,
                    r.PWDDiscount20,
                // Deductions - Discount - NAAC
                    r.naacSPDiscount,
                // Deductions - Discount - Solo Parent
                    r.specialTenPercentDiscount,
                // Deductions - Discount - MOV  
                    r.movSPDiscount,
                // Deductions - Discount - Others
                    r.regularDiscount,
            // Deductions - Return
                r.totalReturns,
            // Deductions - Refund
                r.totalRefund,
            // Deductions - Void
                 r.totalVoids,
            // Deductions - Total
                r.totalDeductions,

        // AOV
            // AOV - Discount
                // AOV - Discount - Regular
                    r.adjustmentOnVatRegular,
                // AOV - Discount - Special 5%
                    r.SCDiscount,
                // AOV - Discount - Special 20%
                    r.PWDDiscount,
                // AOV - Discount - Others
                    r.adjSpecialTenPercentDiscount,
            // AOV - Return
                r.adjustmentOnVatReturns,
            // AOV - Refund
                r.adjustmentOnVatRefund,
            // AOV - Void
                r.adjustmentOnVatVoids,
            // AOV - Total
                r.totalVatAdjustments,

        r.vatPayables,
        r.netAmountReceived,

        // OI
            // OI - Excess GC
                r.excessGC,
            // OI - Excess RS
                r.excessRS,
            // OI - Total OI 
                r.otherIncomeTotal,

        r.totalIncome,
        r.siResetCount,
        r.zReadingCounter
    ]);

    // ======================
    // 4. TITLE ROWS
    // ======================
    function padRowLeftRight(leftValue, rightValue) {
        const r = Array(TOTAL_COLS).fill("");
        r[0] = leftValue || "";
        if (rightValue) r[RIGHT_START] = rightValue;
        return r;
    }

    function centerRow(ws, rowIndex, totalCols) {
        for (let c = 0; c < totalCols; c++) {
            const cell = XLSX.utils.encode_cell({ r: rowIndex, c });
            if (!ws[cell]) continue;

            ws[cell].s = {
                alignment: {
                    horizontal: "center",
                    vertical: "center",
                    wrapText: true
                }
            };
        }
    }


    let titleRows = [
        ["BIR CONSOLIDATED REPORT"],
        [base.site_company || ""],
        [(base.site_tin && base.site_tin_branch_code) ? base.site_tin + "-" + base.site_tin_branch_code : ""],
        [base.site_address || ""],
        [],
        padRowLeftRight("Software: Barter POS Version 5.1", "Branch Code: " + (base.site_refcode || "")),
        padRowLeftRight("", "Branch Name: " + (base.site_name || "")),
        padRowLeftRight("", ""),
        padRowLeftRight("", "")
    ];

    const dateLabel = (this.searchDateFrom === this.searchDateTo)
        ? "Date: " + moment(this.searchDateFrom).format(this.dateFormat)
        : "Date Range: From " + moment(this.searchDateFrom).format(this.dateFormat) +
          " to " + moment(this.searchDateTo).format(this.dateFormat);

    titleRows.push(padRowLeftRight(dateLabel, "Cashier ID: " + (base.user_name || "")));

    // pad title rows
    for (let i = 0; i < titleRows.length; i++) {
        if (titleRows[i].length !== TOTAL_COLS) {
            const r = Array(TOTAL_COLS).fill("");
            if (titleRows[i][0]) r[0] = titleRows[i][0];
            titleRows[i] = r;
        }
    }

    // ======================
    // 5. BUILD SHEET
    // ======================
    const paddedHeader = header.map(r => {
        const row = r.slice();
        while (row.length < TOTAL_COLS) row.push("");
        return row;
    });

    const paddedDataRows = rows.map(r => {
        const row = r.slice();
        while (row.length < TOTAL_COLS) row.push("");
        return row;
    });

    const sheetData = [...titleRows, ...paddedHeader, ...paddedDataRows];

    const titleMerges = [
        { s:{r:0,c:0}, e:{r:0,c:TOTAL_COLS-1} },
        { s:{r:1,c:0}, e:{r:1,c:TOTAL_COLS-1} },
        { s:{r:2,c:0}, e:{r:2,c:TOTAL_COLS-1} },
        { s:{r:3,c:0}, e:{r:3,c:TOTAL_COLS-1} }
    ];

    const ROW_OFFSET = titleRows.length;
    const shiftedMerges = merges.map(m => ({
        s:{ r:m.s.r + ROW_OFFSET, c:m.s.c },
        e:{ r:m.e.r + ROW_OFFSET, c:m.e.c }
    }));

    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    ws['!merges'] = [...titleMerges, ...shiftedMerges];
    ws['!cols'] = Array(TOTAL_COLS).fill({ wch: 18 });

    // ======================
    // CENTER HEADER
    // ======================
    const HEADER_START = titleRows.length;
    const HEADER_END   = HEADER_START + header.length;

    for (let r = HEADER_START; r < HEADER_END; r++) {
        centerRow(ws, r, TOTAL_COLS);
    }

    // ======================
    // 6. EXPORT
    // ======================
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "BIR Consolidated Report");
    XLSX.writeFile(wb, "bir_consolidated_report.xlsx", {
        cellStyles: true
    });

}



        }
    };
</script>

<style></style>
